import * as React from 'react';
import { connect } from 'react-redux';
import { updateBreadCrumbs } from '../../../redux/Actions/BreadCrumbs/ActionCreators';

import {
  errorToast,
  executeExportCommand,
  IErrorMessage,
  IExportCommand,
  IMenuCommand,
  List,
  MimeTypes,
  renderToastContainer
} from 'enchoice-fabric-react-lib';
import { SelectionMode } from 'office-ui-fabric-react';
import { IBreadcrumbItem } from 'office-ui-fabric-react/lib/Breadcrumb';
import { ICommandBarItemProps } from 'office-ui-fabric-react/lib/CommandBar';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';
import { IObjectWithKey, Selection } from 'office-ui-fabric-react/lib/Selection';
import { Dispatch } from 'redux';
import { IBreadCrumbsAction } from '../../../redux/Actions/BreadCrumbs/ActionTypes';
import DocumentPreview from '../DocumentPreview/DocumentPreview';

import { CommandBar } from 'office-ui-fabric-react/lib/CommandBar';

// import { ContextualMenuItemType, IContextualMenuProps } from 'office-ui-fabric-react/lib/ContextualMenu';

import { withTranslation } from 'react-i18next';

import Api from '../../../components/Api';

import { AllMenuCommandsEnum } from '../../../utils/MenuItems.types';

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    updateBreadCrumbs: (items: IBreadcrumbItem[]) => dispatch(updateBreadCrumbs(items))
  };
};

const hOffsite = '40px';
const divStyle = {
  height: `calc(100% - ${hOffsite})`,
  fallbacks: [
    { height: `-moz-calc(100% - ${hOffsite})` },
    { height: `-webkit-calc(100% - ${hOffsite})` },
    { height: `-o-calc(100% - ${hOffsite})` }
  ]
};

const excelExportCommand: IExportCommand = {
  contentType: MimeTypes.XLSX,
  fileType: 'xlsx',
  urlCommand: 'export'
};

const pdfExportCommand: IExportCommand = {
  contentType: MimeTypes.PDF,
  fileType: 'pdf',
  urlCommand: 'export'
};

export interface ISearchResultsProps {
  templateId: number;
  requestData: string;
  match: any;
  location: any;
  updateBreadCrumbs(param: IBreadcrumbItem[]): IBreadCrumbsAction;
}

class SearchResults extends React.PureComponent<any, any> {
  private selectedElems: IObjectWithKey[] = [];
  private selection: Selection;

  constructor(props: any) {
    super(props);

    const {
      match: { params }
    } = this.props;

    this.state = {
      templateId: params.templateId,
      properties: params.properties,
      menuItems: [],
      showPanel: false,
      documentId: -1
    };

    this.isNull = this.isNull.bind(this);
    this.getUrl = this.getUrl.bind(this);
    this.onSelectionChanged = this.onSelectionChanged.bind(this);

    this.selection = new Selection({
      onSelectionChanged: () => {
        this.onSelectionChanged(this.selection.getSelection());
      }
    });
  }

  public componentDidMount() {
    const { t } = this.props;

    this.loadMenuItems();

    const items: IBreadcrumbItem[] = [
      { text: t('searchResults.breadcrumb.home'), key: '/home' },
      { text: t('searchResults.breadcrumb.search'), key: '/search/template/' + this.state.templateId },
      {
        text: t('searchResults.breadcrumb.results'),
        key: '/search/template/' + this.state.templateId + '/results',
        isCurrentItem: true
      }
    ];
    this.props.updateBreadCrumbs(items);
  }

  public render(): JSX.Element {
    const { menuItems } = this.state;
    return (
      <div style={{ height: '100%', width: '100%', display: 'flex', flexDirection: 'column', flex: 1 }}>
        <CommandBar items={menuItems} styles={{ root: { padding: 0 } }} />
        {/*   <div style={{ width: '100%', marginTop: '20px' }}>
          <Title title="Search By Template" icon={true} />
        </div> */}
        <div style={divStyle}>
          <List
            getUrl={this.getUrl}
            handleResponse={this.handleResponse}
            selectionMode={SelectionMode.multiple}
            enableSearch={false}
            enableSort={true}
            selection={this.selection}
            height={'100%'}
            // onItemContextMenu={this.onItemContextMenu}
            overrideDevice={true}
            styles={{ root: { height: '100%', padding: 0 } }}
          />
        </div>
        <div>
          {this.state.documentId != null && (
            <Panel
              isBlocking={false}
              isOpen={this.state.showPanel}
              type={PanelType.medium}
              isHiddenOnDismiss={false}
              onDismiss={this.closePanel}
              closeButtonAriaLabel="Close"
            >
              <DocumentPreview id={this.state.documentId} />
            </Panel>
          )}
        </div>
        <div>{renderToastContainer()}</div>
      </div>
    );
  }

  private loadMenuItems = (): void => {
    const { templateId } = this.state;
    const url = `templates/${templateId}/menu`;
    const newMenuItems: ICommandBarItemProps[] = [];

    Api.get(url)
      .then((response: any) => {
        const data = response.data;
        const commands: IMenuCommand[] = data.items;
        const iconOnlyValue = !data.textMode;

        const excelCmdItem = this.getMenuCommandIfExists(commands, AllMenuCommandsEnum.XLSX, iconOnlyValue, this.exportToExcel);
        if (excelCmdItem) {
          newMenuItems.push(excelCmdItem);
        }

        const pdfCmdItem = this.getMenuCommandIfExists(commands, AllMenuCommandsEnum.PDF, iconOnlyValue, this.exportToPdf);
        if (pdfCmdItem) {
          newMenuItems.push(pdfCmdItem);
        }

        this.setState({
          menuItems: newMenuItems
        });
      })
      .catch(error => this.renderError('Error!', 'Error Loading Menus', error));
  };

  private getMenuCommandIfExists = (
    commands: IMenuCommand[],
    command: IMenuCommand,
    iconOnlyValue: boolean,
    funcToExecute: any
  ): ICommandBarItemProps | undefined => {
    const cmdExist = commands.some(cmd => cmd.id === command.id);
    let item: ICommandBarItemProps | undefined = undefined;

    if (cmdExist) {
      item = {
        key: command.id,
        name: command.name,
        iconProps: {
          iconName: command.icon
        },
        iconOnly: iconOnlyValue,
        onClick: () => {
          funcToExecute();
        }
      };
    }
    return item;
  };

  private showPanel = (): void => {
    this.setState({ showPanel: true });
  };

  private closePanel = (): void => {
    this.setState({ showPanel: false });
  };

  private onSelectionChanged(selection: IObjectWithKey[]): any {
    this.selectedElems.splice(0, this.selectedElems.length, ...selection);

    if (selection.length !== 1) {
      return false;
    }

    const item = selection[0] as any;
    console.log('Selected', item.id);
    this.setState({ documentId: null }, () => this.setState({ documentId: item.id }, () => this.showPanel()));
  }

  private isNull(value: any) {
    return value == null || value === 'null' || value === undefined;
  }

  private handleResponse(items: any[]) {
    return items;
  }

  private getUrl(search: string, page: number, sortBy?: string, sortDesc?: boolean) {
    const qValue = this.isNull(search) ? '' : `&q=${search}`;
    const sortByValue = this.isNull(sortBy) ? '' : `&_sort=${sortBy}`;
    let sortDescValue = '';

    if (!this.isNull(sortDesc)) {
      sortDescValue = sortDesc ? '&_order=desc' : '&_order=asc';
    }

    const url = `documents${this.props.location.search}&_start=${page}&_limit=20${qValue}${sortByValue}${sortDescValue}`;
    console.log(url);
    return url;
  }

  private renderError = (ttl: string, msg: string, retError: any): any => {
    const errorMsg: IErrorMessage = {
      title: ttl,
      message: msg,
      error: retError
    };
    errorToast(errorMsg);
  };

  private getSelectionIds = (): string[] => {
    const selection = this.selection.getSelection();

    if (!selection || selection.length === 0) {
      return [];
    }

    const ids: string[] = [];

    selection.forEach((item: any) => {
      const id = item.id;
      ids.push(id);
    });

    return ids;
  };

  private exportToExcel = (): void => {
    const ids: string[] = this.getSelectionIds();
    executeExportCommand('', this.state.templateId, excelExportCommand, ids);
  };

  private exportToPdf = (): void => {
    const ids: string[] = this.getSelectionIds();
    executeExportCommand('', this.state.templateId, pdfExportCommand, ids);
  };

  /*
  private onItemContextMenu(item: any, index: number, ev: MouseEvent) {
    const empty = {} as IContextualMenuProps;

    if (index <= -1) {
      return empty;
    }

    const contextualMenuProps: IContextualMenuProps = {
      target: ev.target as HTMLElement,
      items: [
        {
          key: 'section' + item.key,
          itemType: ContextualMenuItemType.Section,
          sectionProps: {
            key: 'sectionProps' + item.key + '1',
            topDivider: true,
            bottomDivider: true,
            title: 'Export Actions',
            items: [
              {
                key: 'Mail' + item.key,
                text: 'Excel',
                iconProps: {
                  iconName: 'ExcelDocument'
                },
                onClick: () => console.log(item)
              },
              {
                key: 'deleteItem' + item.key,
                text: 'Pdf',
                iconProps: {
                  iconName: 'Pdf'
                },
                onClick: () => console.log(item)
              }
            ]
          }
        },
        {
          key: 'section2' + item.key,
          itemType: ContextualMenuItemType.Section,
          sectionProps: {
            key: 'sectionProps' + item.key + '2',
            title: 'Document Actions',
            items: [
              {
                key: 'share' + item.key,
                text: 'Download',
                iconProps: {
                  iconName: 'Download'
                },
                onClick: () => console.log(item)
              }
            ]
          }
        }
      ]
    };

    return contextualMenuProps;
  }
  */
}

export default connect(
  null,
  mapDispatchToProps
)(withTranslation()(SearchResults));
